import { Button } from 'antd';
import { Plus, ShieldAlert } from 'lucide-react';
import { useState } from 'react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../../shared/components/EmptyState';
import { PageHeader } from '../../../shared/components/PageHeader';
import { TableSkeleton } from '../../../shared/components/TableSkeleton';
import { buildCustomerColumns } from '../components/build-customer-columns';
import { CreateCustomerDrawer } from '../components/CreateCustomerDrawer';
import { CustomersTable } from '../components/CustomersTable';
import { useCustomers } from '../hooks/use-customers';
import { sectionTrail } from '../../../shared/components/section-trail';

export function CustomersPage() {
  const { state, list, isRefreshing, createError, creating, create, resetCreateError } = useCustomers();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  const columns = buildCustomerColumns({ list });

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('customers')}
        title="Customers"
        description="Customers, credit limits and billing preferences."
        actions={
          <Button
            type="primary"
            icon={<Plus className="size-4" />}
            onClick={() => {
              resetCreateError();
              setDrawerOpen(true);
            }}
          >
            Create customer
          </Button>
        }
      />
      {state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load customers" description="Something went wrong loading the customers list. Try reloading the page." />
      )}
      {state.status === 'loading' && <TableSkeleton label="Loading customers" withSearch />}
      {state.status === 'loaded' && <CustomersTable page={state.page} columns={columns} list={list} isRefreshing={isRefreshing} />}
      <CreateCustomerDrawer open={drawerOpen} error={createError} submitting={creating} onCreate={create} onClose={() => setDrawerOpen(false)} />
    </>
  );
}
